import { cn } from '@commenda/utils';
import React from 'react';
import { TableHead as THead } from '../../Table';
import { ColumnResizeControl, CustomColumnDef } from '../types';
import { ColumnResizeHandle } from './ColumnResizeHandle';
import { ColumnOptionsPopover } from './ColumnOptionsPopover';
import { SortIndicator } from './SortIndicator';

type HeaderCellProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  sort?: {
    direction: 'asc' | 'desc' | null;
    onToggle: (event: unknown) => void;
  };
  columnOptions?: {
    columnDef: CustomColumnDef<unknown, unknown>;
    onSortAsc: () => void;
    onSortDesc: () => void;
    onHideColumn: () => void;
  };
  /** Present for resizable columns; renders the shared drag handle. */
  resizeControl?: ColumnResizeControl;
};

export function HeaderCell({
  children,
  className = '',
  style,
  sort,
  columnOptions,
  resizeControl,
}: HeaderCellProps) {
  const content =
    sort || columnOptions ? (
      <div className="flex items-center gap-sm">
        <div className="flex-1 flex items-center gap-sm">
          {children}
          {sort ? (
            <SortIndicator direction={sort.direction} onClick={sort.onToggle} />
          ) : null}
        </div>
        {columnOptions ? (
          <ColumnOptionsPopover
            columnDef={columnOptions.columnDef}
            onSortAsc={columnOptions.onSortAsc}
            onSortDesc={columnOptions.onSortDesc}
            onHideColumn={columnOptions.onHideColumn}
          />
        ) : null}
      </div>
    ) : (
      children
    );

  return (
    <THead
      className={cn(
        'relative h-10 text-left align-middle txt-extra-small-bold text-text-primary',
        className
      )}
      style={style}
    >
      {content}
      {resizeControl && <ColumnResizeHandle control={resizeControl} />}
    </THead>
  );
}

export default HeaderCell;
